import React from 'react';
import { Building2, UsersRound } from 'lucide-react';
import { cn } from '../../ui';

/**
 * ScopeTabs
 *
 * Selector de scope (Interno GRUPOLAE / Colaboradores) usado en el
 * Dashboard y reutilizable en Lista de activos, Historial, etc.
 *
 * Diseño sobrio del DS v2:
 *   - Barra inferior tipo tabs (no pills llamativas).
 *   - Tab activo: texto e icono en azul corporativo + borde inferior.
 *   - Tab inactivo: gris, hover suave.
 *   - Pequeña etiqueta de scope a la derecha de cada tab.
 *
 * Props:
 *   value: 'interno' | 'colab'
 *   onChange: (scope) => void
 *   className?: string
 */

const TABS = [
  { id: 'interno', label: 'GRUPOLAE', pill: 'Interno', Icon: Building2 },
  { id: 'colab', label: 'Colaboradores', pill: 'Colab', Icon: UsersRound },
];

export default function ScopeTabs({ value, onChange, className }) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 border-b border-slate-200 mb-4',
        className
      )}
      role="tablist"
      aria-label="Ámbito del inventario"
    >
      {TABS.map(({ id, label, pill, Icon }) => {
        const active = value === id;
        return (
          <button
            key={id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(id)}
            className={cn(
              'flex items-center gap-2 px-4 py-2.5 text-sm font-medium',
              'border-b-2 -mb-px transition-colors',
              active
                ? 'border-[hsl(var(--brand-light))] text-[hsl(var(--brand-light))]'
                : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300'
            )}
          >
            <Icon className="w-4 h-4" />
            <span>{label}</span>
            <span
              className={cn(
                'text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 rounded',
                active
                  ? 'bg-[hsl(var(--brand-light))] text-white'
                  : 'bg-slate-100 text-slate-500'
              )}
            >
              {pill}
            </span>
          </button>
        );
      })}
    </div>
  );
}
